import { Box, Divider, IconButton, InputBase } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { Close } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { TSearchProps } from './types';

export const Search: FC<TSearchProps> = ({ searchParams = '' }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const { search } = useLocation();
	const navigateParams = queryString.parse(search);

	const [change, setChange] = useState(false);
	const [searchString, setSearchString] = useState('');
	const [value] = useDebounce(searchString, 1000);

	useEffect(() => {
		if (change) {
			// onChange(value);
			navigate({
				pathname: location.pathname,
				search: `?${queryString.stringify({
					...navigateParams,
					search: value,
					page: 1,
				})}`,
			});
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value]);

	useEffect(() => {
		const paramValue = (navigateParams.search as string) || '';
		setSearchString(paramValue);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [search]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setChange(true);
		setSearchString(e.target?.value ?? '');
	};

	const handleClear = () => {
		setChange(true);
		setSearchString('');
	};
	return (
		<Box
			component="div"
			sx={{
				display: 'flex',
				alignItems: 'center',
				width: '300px',
				borderRadius: '12px',
				borderWidth: '1px',
				borderStyle: 'solid',
				borderColor: 'primary.main',
				fontSize: '.9rem',
				p: 0,
				m: 0,
			}}
		>
			{/* <Button
				color="primary"
				sx={{
					p: 0,
					m: 0,
					idTransform: 'none',
					fontWeight: '900',
					fontFamily: 'monospace',
					minWidth: '30px',
					textTransform: 'lowercase',
				}}
				//  onClick={handleClear}
			>
				i
				<InfoDial text="The search will be conducted based on a full match with the EAS order ID or a partial match with the store's order number. All other filters will be reset." />
			</Button>
			<Divider sx={{ height: 18 }} orientation="vertical" /> */}

			<InputBase
				sx={{
					ml: 0,
					flex: 1,
					fontSize: '.9rem',
					p: '2px 4px',
					'& input': {
						padding: '4px 4px',
						fontSize: '.9rem',
						'&::placeholder': {
							fontSize: '.8rem',
						},
					},
				}}
				style={{ padding: 0 }}
				size="small"
				fullWidth
				placeholder={`Enter ${searchParams}`}
				inputProps={{
					autoComplete: 'new-password',
				}}
				onChange={handleChange}
				value={searchString}
			/>
			<Divider sx={{ height: 18, m: 0.5 }} orientation="vertical" />
			<IconButton
				color="primary"
				sx={{ p: '0 5px 0 0' }}
				aria-label="directions"
				onClick={handleClear}
			>
				<Close fontSize="small" />
			</IconButton>
		</Box>
	);
};
